import script from "./EnterPasswordComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EnterPasswordComponent.vue?vue&type=script&setup=true&lang=js"

import "./EnterPasswordComponent.vue?vue&type=style&index=0&id=55118f26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55118f26"]])

export default __exports__